export default "__VITE_ASSET__I1OP5eMa__"